import router from "@/router";
import {
    BAD_REQUEST_ERROR_CODE,
    CARD_BRAND_AMERICAN_EXPRESS,
    CARD_BRAND_JCB,
    CARD_BRAND_MASTER,
    CARD_BRAND_VISA
} from "@/data/constants";
import creditcardCheckerjs from "creditcard-checkerjs";

export function getLocale(locale) {
    let url = new URL(location.href);

    if (url.searchParams.get('location')) {
        return url.searchParams.get('location');
    }

    if (locale) {
        return locale
    }

    return 'ja';
}

export function cssFile(fileName, baseUrl) {
    let link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', baseUrl + 'assets/css/' + fileName);
    document.head.appendChild(link);
}

export async function handleError(error){
    if(error.response.data != undefined && error.response.data != null){
        const data = error.response.data;

        if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "object") {
            return Object.values(data.errors)[0];
        }
    
        if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "string") {
            return data.errors;
        }
    }

    await router.push({ name: "internal.server.error" });
}

export function getCreditCardBrand(cardNumber) {
    // get card brand name card based on number
    const brandName = creditcardCheckerjs.cardtype(cardNumber);
    const hubsynchCardBrandIdMap = {
        VISA: CARD_BRAND_VISA,
        JCB: CARD_BRAND_JCB,
        MASTER: CARD_BRAND_MASTER,
        AMEX: CARD_BRAND_AMERICAN_EXPRESS
    };
    return hubsynchCardBrandIdMap[brandName] || null
}

export function loadPaygentScript() {
    return new Promise((resolve, reject) => {
        if (window.PaygentToken) {
            resolve(window.PaygentToken)
            return
        }

        const script = document.createElement('script')
        script.src = 'https://sandbox.paygent.co.jp/js/PaygentToken.js'
        script.onload = () => resolve(window.PaygentToken)
        script.onerror = reject

        document.head.appendChild(script)
    })
}